import {
  BookOpenIcon,
  ChartBarIcon,
  CircleStackIcon,
  DocumentTextIcon,
  PresentationChartLineIcon,
  RocketLaunchIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';
import type { DocsIconKey } from './navMenuConfig';

const ICON_CLASS = 'nav-mega-docs-item__icon-svg';

export function DocsMenuIcon({ icon }: { icon: DocsIconKey }) {
  switch (icon) {
    case 'book':
      return <BookOpenIcon className={ICON_CLASS} aria-hidden />;
    case 'rocket':
      return <RocketLaunchIcon className={ICON_CLASS} aria-hidden />;
    case 'chart':
      return <ChartBarIcon className={ICON_CLASS} aria-hidden />;
    case 'database':
      return <CircleStackIcon className={ICON_CLASS} aria-hidden />;
    case 'metrics':
      return <PresentationChartLineIcon className={ICON_CLASS} aria-hidden />;
    case 'document':
      return <DocumentTextIcon className={ICON_CLASS} aria-hidden />;
    case 'ontology':
      return <ShareIcon className={ICON_CLASS} aria-hidden />;
    default:
      return <CircleStackIcon className={ICON_CLASS} aria-hidden />;
  }
}
